import { render, staticRenderFns } from "./BFoot.vue?vue&type=template&id=c142ae7a&scoped=true&"
import script from "./BFoot.vue?vue&type=script&lang=js&"
export * from "./BFoot.vue?vue&type=script&lang=js&"
import style0 from "./BFoot.vue?vue&type=style&index=0&id=c142ae7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c142ae7a",
  null
  
)

export default component.exports